import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { Select } from "../../Select/index.js";
const AGE_TEXT = 'yrs';
const DEFAULT_TEXT = 'Required';
const DEFAULT_OPTION = {
    value: '',
    label: ''
};
const SELECT_SLOTS = {
    inputWrapper: [
        'w-50'
    ],
    popupPositioner: 'z-1'
};
const HOTEL_OPTIONS = buildOptions(true);
const NON_HOTEL_OPTIONS = buildOptions(false);
function buildOptions(isHotel) {
    const options = [];
    for(let i = 0; i <= 17; i++){
        let label = `${i} ${AGE_TEXT}`;
        if (0 === i) label = isHotel ? 'Infant' : '0-1 Infant in lap';
        else if (1 === i) label = isHotel ? '1 yr' : '0-1 Infant in seat';
        options.push({
            label,
            value: String(i)
        });
    }
    return options;
}
function ChildAgeSelectComponent({ index, isHotel = false, value, onChange }) {
    const handleChange = useCallback((newValue)=>{
        onChange(index, newValue);
    }, [
        onChange,
        index
    ]);
    const options = isHotel ? HOTEL_OPTIONS : NON_HOTEL_OPTIONS;
    const selectedOption = useMemo(()=>options.find((option)=>option.value === value) ?? DEFAULT_OPTION, [
        options,
        value
    ]);
    const labelText = `Age of Child ${index + 1}`;
    return /*#__PURE__*/ jsx("div", {
        className: "my-2 flex w-full items-center justify-between",
        children: /*#__PURE__*/ jsxs("div", {
            className: "flex w-full items-center justify-between gap-2 overflow-hidden text-ellipsis",
            children: [
                /*#__PURE__*/ jsx("label", {
                    htmlFor: `child-age-${index}`,
                    className: "text-body2 whitespace-nowrap",
                    children: labelText
                }),
                /*#__PURE__*/ jsx(Select, {
                    label: labelText,
                    isLabelHidden: true,
                    menuItems: options,
                    placeholder: selectedOption.label || DEFAULT_TEXT,
                    initialValue: value ?? '',
                    onChange: handleChange,
                    size: "sm",
                    slots: SELECT_SLOTS
                })
            ]
        })
    });
}
const ChildAgeSelect = /*#__PURE__*/ memo(ChildAgeSelectComponent);
export { ChildAgeSelect };
